import { useEffect, useState } from "react";
import {
  WebViewContainer,
  NoLoyaltyText,
  HeaderContainer,
  PageTitle,
  HeaderSkirt,
  ContentContainer,
  FieldContainer,
  FieldTitle,
  FieldValue,
} from "./components/StyledComponents";
import LoyaltyForm from "./components/LoyaltyForm";
import axios from "axios";
import { webviewData, loyaltyData } from "./sample_data";

function App() {
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState("");

  const cartData =
    window?.NEWSTORE?.contextProps?.cart || webviewData.contextProps.cart;
  const storeData =
    window?.NEWSTORE?.contextProps?.store || webviewData.contextProps.store;
  const token = window?.NEWSTORE?.securityToken || "";

  const dimensions = window?.NEWSTORE?.dimensions || webviewData.dimensions;
  const theme = window?.NEWSTORE?.theme || webviewData.theme;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let res;
        if (window.NEWSTORE) {
          const payload = {
            email: cartData.customerEmail,
            countryCode: storeData.countryCode,
          };
          const responseFromAxios = await axios.post("/api/loyalty", payload, {
            headers: {
              "Content-Type": "application/json",
            },
          });
          res = responseFromAxios.data;
        } else {
          // For local testing with webViewData
          res = loyaltyData;
        }
        setResponse(res);
      } catch (err) {
        console.error("error: ", err);
      }

      setLoading(false);
    };

    fetchData();
  }, [cartData.customerEmail, storeData.countryCode]);

  // Handle input change
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Clear any prior server error, then show blur/spinner:
    setServerError("");
    setIsSubmitting(true);

    try {
      const payload = {
        email: cartData.customerEmail,
        vouchers: [
          {
            currency: cartData.currency,
            discount: Number(inputValue),
            rewardId: response?.CustomerLoyalty?.RewardsList[0].Reward.RewardId,
          },
        ],
      };

      const responseFromAxios = await axios.post(
        "/api/create-coupon",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const codesArray = responseFromAxios.data.codes || [];
      const selectedCoupons = cartData.selectedCoupons;
      const allCoupons = [...selectedCoupons, ...codesArray];

      const newCouponsUrlParams = allCoupons
        .map(
          (code, idx) =>
            `coupons[]=${encodeURIComponent(code)}${
              allCoupons.length - 1 === idx ? "" : "&"
            }`,
        )
        .join("");

      const discountDeeplink = `com.newstore.associate-one://cart.more.loyaltyProgram/applyCoupons?${newCouponsUrlParams}&cartId=${window?.NEWSTORE?.contextProps?.cart.cartId}&token=${token}`;
      setIsSubmitting(false);
      window.location.href = discountDeeplink;
    } catch (err) {
      console.error("Error creating/applying coupon:", err);
      setServerError("Coupon couldn’t be created/applied now.");
      setIsSubmitting(false);
    }
  };

  // While loading, show a loading spinner or a placeholder.
  if (loading) {
    return (
      <WebViewContainer>
        <NoLoyaltyText>Loading...</NoLoyaltyText>
      </WebViewContainer>
    );
  }

  const textFields = [
    {
      title: "Customer Name",
      value: response?.CustomerLoyalty?.CustomerName,
    },
    {
      title: "Available Balance",
      value: response?.CustomerLoyalty?.AvailableRewards,
    },
  ];

  return !response?.CustomerLoyalty ? (
    <WebViewContainer>
      <NoLoyaltyText>User is not enrolled in loyalty!</NoLoyaltyText>
    </WebViewContainer>
  ) : (
    <WebViewContainer>
      <HeaderContainer>
        <PageTitle>Customer Loyalty</PageTitle>
        <HeaderSkirt />
      </HeaderContainer>

      <ContentContainer dimensions={dimensions} blur={isSubmitting}>
        <FieldContainer>
          {textFields.map((field, index) => (
            <div
              key={field.title}
              style={{
                paddingTop: index > 0 ? theme.spacing12 : 0,
              }}
            >
              <FieldTitle>{field.title}</FieldTitle>
              <FieldValue>{field.value}</FieldValue>
            </div>
          ))}
        </FieldContainer>

        <FieldContainer>
          <LoyaltyForm
            inputValue={inputValue}
            availableAmount={response?.CustomerLoyalty?.AvailableRewards}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            serverError={serverError}
            isSubmitting={isSubmitting}
          />
        </FieldContainer>
      </ContentContainer>
    </WebViewContainer>
  );
}

export default App;
